export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm text-foreground-500">有料你就来，欢迎投稿与爆料</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <div className="bg-background-50 rounded-lg border border-background-300/40 p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-accent-500/15 flex items-center justify-center">
                <i className="ri-mail-send-line text-2xl text-accent-400"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">投稿 / 爆料 / 商务合作</h3>
              <p className="text-sm text-foreground-500 mb-6 leading-relaxed">
                如果你有独家爆料线索、吃瓜素材或商务合作需求，欢迎通过以下方式与我们取得联系。
                我们承诺对所有投稿信息严格保密，爆料人身份绝不公开。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a href="mailto:tips@51anwang.com" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-400 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm cursor-pointer">
                  <i className="ri-mail-line"></i>
                  发送邮件
                </a>
                <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-800 border border-background-300/60 rounded-lg transition-all duration-200 text-sm cursor-pointer">
                  <i className="ri-smartphone-line"></i>
                  APP内投稿
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}